import axios from "@/config/axios";

const initialState = () => {
  return {
    vendors: [],
    vendorsLoading: false,
    vendorsError: null,
  };
};

const state = initialState();

const getters = {
  getAllVendors: (state) => state.vendors,
  getVendorsLoading: (state) => state.vendorsLoading,
  getVendorsError: (state) => state.vendorsError,
  // Get vendor codes for platform dropdown
  getVendorCodes: (state) => state.vendors.map((vendor) => vendor.code),
};

const mutations = {
  setVendors(state, vendors) {
    state.vendors = vendors;
  },
  setVendorsLoading(state, loading) {
    state.vendorsLoading = loading;
  },
  setVendorsError(state, error) {
    state.vendorsError = error;
  },
  reset(state) {
    Object.assign(state, initialState());
  },
};

const actions = {
  async fetchVendors({ commit }, params = {}) {
    try {
      commit("setVendorsLoading", true);
      commit("setVendorsError", null);
      
      const queryParams = {
        skip: params.skip || 0,
        limit: params.limit || 100, // Fetch more to get all vendors
        ...params,
      };
      
      const response = await axios.get("/vendors", { params: queryParams });
            
      let vendorsData = [];
      if (Array.isArray(response.data)) {
        vendorsData = response.data;
      } else if (response.data && typeof response.data === 'object') {
        // Handle case where response might be paginated differently
        const possibleArrayKeys = ['data', 'records', 'items', 'results', 'vendors'];
        for (const key of possibleArrayKeys) {
          if (Array.isArray(response.data[key])) {
            vendorsData = response.data[key];
            break;
          }
        }
      }
      
      // console.log("Parsed vendors data:", vendorsData);
      // console.log("Vendor codes:", vendorsData.map(v => v.code));
      
      commit("setVendors", vendorsData);
      commit("setVendorsLoading", false);
      return response.data;
    } catch (error) {
      console.error("Error fetching vendors:", error);
      commit("setVendorsError", error.message || "Failed to fetch vendors");
      commit("setVendorsLoading", false);
      return null;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
